<template>
  <div>
    <div v-if="agent.agent_id === 5">
      <b-overlay
        :show="isLoading"
        variant="transparent"
        opacity="0.99"
        blur="5px"
        rounded="sm"
      >
        <h4>PG PRO</h4>
        <b-row>
          <b-col md="4">
            <b-card>
              <b-row match-height>
                <b-form-checkbox
                  v-model="toggleAll"
                  name="check-button"
                  switch
                  :value="1"
                  :unchecked-value="0"
                  @change="toggleAllGames()"
                >
                  เปิดทุกเกม AMB
                </b-form-checkbox>
              </b-row>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card>
              <b-row match-height>
                <b-form-checkbox
                  v-model="toggleAll"
                  name="check-button"
                  switch
                  :value="2"
                  :unchecked-value="0"
                  @change="toggleAllGames()"
                >
                  เปิดทุกเกม PG PRO
                </b-form-checkbox>
              </b-row>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card>
              <b-row match-height>
                <b-form-checkbox
                  v-model="toggleAll"
                  name="check-button"
                  switch
                  :value="3"
                  :unchecked-value="0"
                  @change="toggleAllGames()"
                >
                  เปิดทุกเกม PG AI
                </b-form-checkbox>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <transition name="fade">
          <b-card>
            <b-row match-height>
              <b-col
                v-for="item in pgproList"
                :key="item.id"
                sm="4"
                md="3"
                lg="2"
              >
                <b-card
                  no-body
                  class="border overflow-hidden"
                  style="border-radius: 16px; position: relative"
                >
                  <div
                    v-if="
                      item.pgpro_status === 1 ||
                        item.amb_status === 1 ||
                        item.pgai_status === 1
                    "
                    :style="{
                      position: 'absolute',
                      top: '10px',
                      right: '0',
                      backgroundColor:
                        item.setting_game === 2
                          ? 'red'
                          : item.setting_game === 1
                            ? 'blue'
                            : 'green',
                      color: 'white',
                      padding: '4px 8px',
                      borderTopLeftRadius: '4px',
                      borderBottomLeftRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      zIndex: 10,
                    }"
                  >
                    {{
                      item.setting_game === 1
                        ? "AMB"
                        : item.setting_game === 2
                          ? "PG PRO"
                          : "PG AI"
                    }}
                  </div>

                  <img
                    class="w-100 h-100"
                    :src="`https://play.bkbet365.cc/img/games/imgpg/${item.game_code}.png`"
                    style="object-fit: cover"
                  >

                  <div class="mt-1 text-truncate px-1 pb-1">
                    <h6>{{ item.name }}</h6>

                    <b-form-select
                      v-model="item.setting_game"
                      :options="getFilteredOptions(item)"
                      placeholder="ประเภทบัญชี"
                      @change="PGProchangeStatus(item)"
                    />
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-overlay>
    </div>

    <div v-else>
      <b-overlay
        :show="isLoading"
        variant="transparent"
        opacity="0.99"
        blur="5px"
        rounded="sm"
      >
        <h4>PG PRO</h4>
        <b-card>
          <b-row match-height>
            <b-form-checkbox
              v-model="toggleAll"
              name="check-button"
              switch
              :value="1"
              :unchecked-value="0"
              @change="toggleAllGames()"
            >เปิดทุกเกม</b-form-checkbox>
          </b-row>
        </b-card>
        <transition name="fade">
          <b-card>
            <b-row match-height>
              <b-col
                v-for="item in pgproList"
                :key="item.id"
                sm="4"
                md="3"
                lg="2"
              >
                <b-card
                  no-body
                  class="border overflow-hidden"
                  style="border-radius: 16px; position: relative"
                >
                  <div
                    style="
                      position: absolute;
                      top: 10px;
                      right: 0;
                      background-color: red;
                      color: white;
                      padding: 4px 8px;
                      border-top-left-radius: 4px;
                      border-bottom-left-radius: 4px;
                      font-size: 12px;
                      font-weight: bold;
                      z-index: 10;
                    "
                  >
                    PG PRO
                  </div>

                  <img
                    class="w-100 h-100"
                    :src="item.img"
                    style="object-fit: cover"
                  >
                  <div class="mt-1 text-truncate px-1 pb-1">
                    <h6>{{ item.name }}</h6>
                    <b-form-checkbox
                      v-model="item.pgpro_status"
                      name="check-button"
                      switch
                      :value="1"
                      :unchecked-value="0"
                      @change="PGProchangeStatus(item)"
                    />
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </transition>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import {
  BFormCheckbox,
  BRow,
  BCol,
  BModal,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BPagination,
  BTable,
  BCard,
  BCardTitle,
  BCardBody,
  BOverlay,
  BIconController,
  BButton,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment-timezone'

export default {
  components: {
    BFormCheckbox,
    BRow,
    BCol,
    BModal,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BPagination,
    BTable,
    BCard,
    BCardTitle,
    BCardBody,
    BOverlay,
    BIconController,
    BButton,
    flatPickr,
  },
  data: () => ({
    pgproList: [],
    isLoading: false,
    toggleAll: 0,
    toggleAllPGPRO: 0,
    toggleAllPGAI: 0,
    agent: [],
    gamestatus: [
      { value: 0, text: 'ปิด' },
      { value: 1, text: 'AMB' },
      { value: 2, text: 'PG PRO' },
    ],
  }),
  mounted() {
    this.getDataPgproAll()
    this.getDataPgpro()
    this.getAgent()
  },
  methods: {
    getAgent() {
      this.$http
        .get('/agent/show')
        .then(response => {
          this.agent = response.data
          // this.switch(response.data)
          // console.log(response.data)
        })
        .catch(error => console.log(error))
    },
    toggleAllGames() {
      this.isLoading = true

      const payload = {
        game_status: this.toggleAll,
      }
      this.$http.post('/pgpro/changeStatusAll', payload).then(response => {
        if (response.data.success) {
          this.getDataPgpro()
          this.isLoading = false
          this.Success(response.data.mes)
        } else {
          this.SwalError(response.data.mes)
          this.isLoading = false
        }
        this.getDataPgproAll()
      })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: `<h3 style="color: #141414">${mes}</h3>`,
        // text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: `<h3 style="color: #141414">${mes}</h3>`,
        // text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
    async PGProchangeStatus(item) {
      this.isLoading = true
      try {
        console.log(item)

        await this.$http.post('/pgpro/changeStatus', item)

        this.getDataPgpro()
        // console.log(data)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async getDataPgproAll() {
      this.isLoading = true
      try {
        const { data } = await this.$http.get('/pgpro/statusallgames')
        this.toggleAll = Number(data.game_status)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    getFilteredOptions(item) {
      const options = []
      if (item.amb_status === 1) {
        options.push({ value: 1, text: 'AMB' })
      }
      if (item.pgpro_status === 1) {
        options.push({ value: 2, text: 'PG PRO' })
      }
      if (item.pgai_status === 1) {
        options.push({ value: 3, text: 'PG AI' })
      }
      return options
    },
    async getDataPgpro() {
      this.isLoading = true
      try {
        const { data } = await this.$http.get('/pgpro/gamelist')
        this.pgproList = data.Data
        //   .map((item) => ({
        //   ...item,
        //   default_status:
        //     item.amb_status === 1
        //       ? 1
        //       : item.pgpro_status === 1
        //       ? 2
        //       : item.pgai_status === 1
        //       ? 3
        //       : 0,
        // }));
        const gamestatusOptions = []

        if (data.Data.some(item => item.amb_status === 1)) {
          gamestatusOptions.push({ value: 1, text: 'AMB' })
        }
        if (data.Data.some(item => item.pgpro_status === 1)) {
          gamestatusOptions.push({ value: 2, text: 'PG PRO' })
        }
        if (data.Data.some(item => item.pgai_status === 1)) {
          gamestatusOptions.push({ value: 3, text: 'PG AI' })
        }
        this.gamestatus = gamestatusOptions
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

  <style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
